module.exports = __webpack_public_path__ + "img/academic-excellence-poster.22f141ed.png";